export function mapObjectKeys<T>(obj: Record<string, T>, keyMapper: (key: string) => string): { [key: string]: T } {
    return Object.keys(obj).reduce((acc, key) => {
        const newKey = keyMapper(key);
        acc[newKey] = obj[key];
        return acc;
    }, {} as Record<string, T>);
}